var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionMyLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 21.482V22h12v-1.933c0-.51-.255-.987-.68-1.27a9.576 9.576 0 0 0-3.428-1.419 9.685 9.685 0 0 0-3.784 0 9.583 9.583 0 0 0-1.503.431c-.147.23-.294.455-.44.675A51.87 51.87 0 0 1 10 21.482Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.074 15.3a3 3 0 1 0 1.862-5.3c-.167 1.352-.644 2.718-1.207 3.964-.202.448-.423.895-.655 1.336Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 22s7-8 7-13c0-4-3.134-7-7-7S0 5 0 9c0 5 7 13 7 13Zm0-10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionMyLocation);
export default __webpack_public_path__ + "static/media/ic_action_my_location.90b8190fbf7bc31b5dce98c729c3f597.svg";
export { ForwardRef as ReactComponent };